import type { ImportSummary, ListResponse } from '@shared/schemas';

import type { CsmMessageStatus } from '@/features/licence/_shared/ui/contact-csm-dialog.view';

/**
 * Redux state for the client Imports index: a read-only listing of the lists
 * imported by the team. `error` holds a human-readable message when the load
 * fails (surfaced by the page); the old `useApi` version silently swallowed
 * it. Every field is serialisable.
 */
export interface ImportsState {
  rows: ListResponse[];
  /** What the rows cannot give (#695): distinct profiles and the CSM's name; null until loaded. */
  summary: ImportSummary | null;
  loading: boolean;
  error: string | null;
  /** The "Contact My Customer Success Manager" form (#695). */
  csmMessage: { status: CsmMessageStatus; error: string | null };
}

export const initialState: ImportsState = {
  rows: [],
  summary: null,
  loading: false,
  error: null,
  csmMessage: { status: 'idle', error: null },
};
